import { Reducer, Action } from "redux";
import { ICyberRiskAssessmentState, KnownAction, REQUEST_ASSESSMENT_DATA, RECEIVE_ASSESSMENT_DATA, SHOW_LOADER } from "./types";

export const reducer: Reducer<ICyberRiskAssessmentState> = (state: ICyberRiskAssessmentState | undefined, incomingAction: Action): ICyberRiskAssessmentState => {
    if (state === undefined) {
        return { assessmentData: undefined, isLoading: false };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case RECEIVE_ASSESSMENT_DATA:
            return {
                isLoading: false,
                assessmentData: action.assessmentData,
            };
        case REQUEST_ASSESSMENT_DATA:
            return {
                isLoading: true,
                assessmentData: state.assessmentData,
            };
        default:
            return state;
    }
};
